import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/styles'
import { getInitials } from 'lib/text-display'

const useStyles = makeStyles({
  avatar: {
    width: 40,
    height: 40,
    fontSize: '0.875rem',
    fontWeight: 600,
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
})

const MessagingContactAvatar = ({ name, image, className, ...props }) => {
  const classes = useStyles()

  return (
    <Avatar
      alt={name}
      aria-label={name}
      className={[classes.avatar, className].filter(Boolean).join(' ')}
      src={image || undefined}
      {...props}
    >
      {getInitials(name)}
    </Avatar>
  )
}

export default MessagingContactAvatar
